export default __webpack_public_path__ + "static/media/question-circle.c46cf687.svg";